// extracted by mini-css-extract-plugin
export default {"colorBannerText":"#1a1a1a","secondaryButton":"styles_secondaryButton__mWnPw","buttonContentLoading":"styles_buttonContentLoading__r8iEM","loadingIcon":"styles_loadingIcon__ssv0M"};